import React from "react";

import "./mobileTermsConditions.css";

import { Link, useNavigate } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useState } from "react";
import { useEffect } from "react";
import useScrollToTop from "../../hooks/useScrollToTop";

const MobileTermsConditions = () => {
  // Mobile Responsive
  const [windowDimension, setWindowDimension] = useState(null);
  const navigate = useNavigate();

  useScrollToTop();

  useEffect(() => {
    setWindowDimension(window.innerWidth);
  }, []);

  useEffect(() => {
    function handleResize() {
      setWindowDimension(window.innerWidth);
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowDimension <= 640;
  // Mobile Responsive

  return (
    <div className="mobileTermsConditions">
      <div className="mobileTermsConditions-wrapper">
        {isMobile ? (
          <div className="mobileTermsConditions-top-goback">
            <div
              className="mobileTermsConditions-backButton"
              onClick={() => navigate(-1)}
            >
              <div className="arrow">
                <ArrowBackIosIcon className="icon" />
              </div>
              <p>Terms and conditions</p>
            </div>
          </div>
        ) : (
          <div className="mobileTermsConditions-top-goback">
            <div
              className="mobileTermsConditions-backButton"
              onClick={() => navigate(-1)}
            >
              <div className="arrow">
                <ArrowBackIosIcon className="icon" />
              </div>
              <p>Terms and conditions</p>
            </div>
          </div>
        )}

        <div className="mobileTermsConditions-bottom">
          <div className="mobileTermsConditions-content-wrapper">
            <h3>How it works ?</h3>
            <p>
              Users need to register or log in to the FIFA World Cup 2026
              Prediction Game, which will be available across multiple
              platforms, the Playspots app and the
              dedicated prediction portal. After logging in, fans can make their
              predictions for each match.Steps to follow:
              <ol>
                <li>
                  Sign in to the FIFA World Cup Prediction Game 2026 to
                  play the contest from June 12 – July 20, 2026 (104
                  matches).
                </li>
                <li>
                  Make your predictions by answering the questions related to
                  each match.
                </li>
                <li>You can change your answer until the specified time.</li>
                <li>
                  One daily winner will be selected based on the highest points
                  earned in that day’s predictions.
                </li>
                <li>
                  With every correct prediction, you improve your chances of
                  winning the grand prizes.
                </li>
                <li>
                  The more you play, the greater your chances of predicting the
                  correct winning team, bringing you closer to winning the Grand
                  Prizes.
                </li>
              </ol>
            </p>
          </div>
          <div className="mobileTermsConditions-content-wrapper">
            <h3>Points</h3>
            <p>
              Predict the correct match results to gain points. Points will be
              according to the questions. Users can predict multiple questions
              at the same time. The leaderboard will be updated after each match
              result. Photo of the daily winner will be displayed on the
              website/app. Predictions can be made or modified until the
              specified time. All timings displayed are in IST (Indian Standard
              Time).
            </p>
          </div>
          <div className="mobileTermsConditions-content-wrapper">
            <h3>Winners & Prizes</h3>

            <h5>Daily Winner</h5>
            <p>
              Each question carries fixed points, which are shown above the
              questions. The daily prize will be awarded to the participant with
              the highest points. If multiple participants have the same highest
              score, the winner will be randomly selected from among them. If we
              are unable to get in touch with the selected winner, another
              participant will be randomly chosen.
            </p>
            <h5>Weekly Winner</h5>
            <p>
              Based on who has the highest points each week, one player will be
              selected as the weekly winner. If multiple participants have the
              same highest points, the winner will be chosen by random. If we
              couldn’t get in touch with the selected winner, we’ll pick another
              participant from the list by random.
            </p>
            <h5>Mega Winners</h5>
            <p>
              Based on the highest points, multiple mega winners will be chosen
              at the end of the season. There will be a 1st prize winner, a 2nd prize winner, and 3rd prize winner. In the event that two or more participants have the same total score and the same number of questions attended, the winner will be determined based on the higher number of correct answers attempted, to ensure fairness in the game.
            </p>
          </div>
          <div className="mobileTermsConditions-content-wrapper">
            <h3>Disclaimer</h3>
            <p>
              This contest is organized by <strong>Media One</strong>{" "}
              and technically powered by <strong>PlaySpots</strong>. Apple Inc.
              is not a sponsor of, nor is it in any way affiliated with, the
              contest or sweepstakes. All inquiries or concerns regarding the
              contest or technical issues should be directed to the PlaySpots. The final decision on all matters related to the contest will rest solely with the Media One team.
            </p>
          </div>
          <div className="mobileTermsConditions-content-wrapper">
            <h3>എങ്ങനെ പങ്കെടുക്കാം?</h3>
            <p>
              FIFA World Cup 2026 Prediction Game 2026-ൽ പങ്കെടുക്കുന്നത് വളരെ
              ലളിതമാണ്. ഈ ഗെയിം Playspots ആപ്പ്,
              പ്രത്യേക Prediction പോർട്ടൽ എന്നിവയിൽ ലഭ്യമാണ്.
              <h6>പങ്കെടുക്കാനുള്ള ഘട്ടങ്ങൾ:</h6>
              <ol>
                <li>
                  ജൂൺ 12 മുതൽ ജൂലൈ 20, 2026 വരെ നടക്കുന്ന FIFA World Cup Prediction Game 2026-ൽ സൈൻ ഇൻ ചെയ്ത് മത്സരത്തിൽ
                  പങ്കെടുക്കുക.
                </li>
                <li>
                  ഓരോ മത്സരത്തിനും നൽകിയിരിക്കുന്ന പ്രവചന ചോദ്യങ്ങൾക്ക് ഉത്തരം
                  നൽകുക.
                </li>
                <li>
                  നിങ്ങളുടെ ഉത്തരങ്ങൾ നിർദ്ദിഷ്ട സമയത്തേക്ക് മാറ്റിക്കൊടുക്കാൻ
                  കഴിയും.
                </li>
                <li>
                  ദിവസേന ഏറ്റവും കൂടുതൽ പോയിന്റ് നേടിയ daily winnerയെ
                  പ്രഖ്യാപിക്കും.
                </li>
                <li>
                  ശരിയായ പ്രവചനങ്ങൾ വർധിപ്പിക്കുന്നതിലൂടെ ഗ്രാൻഡ് പ്രൈസുകൾ നേടാനുള്ള സാധ്യത വർധിക്കും.
                </li>
                <li>
                  കൂടുതൽ ദിവസവും കളിക്കൂ, കൂടുതൽ പ്രവചനങ്ങൾ ശരിയാക്കൂ, Season
                  Champion ആകാനുള്ള സാധ്യതകൾ വർധിപ്പിക്കൂ!{" "}
                </li>
              </ol>
            </p>
          </div>
          <div className="mobileTermsConditions-content-wrapper">
            <h3>പോയിന്റുകൾ</h3>
            <p>
              മത്സര ഫലം ശരിയായി പ്രവചിക്കുന്നവർക്ക് പോയിന്റുകൾ ലഭിക്കും. ഓരോ
              ചോദ്യത്തിനും പോയിന്റ് വ്യത്യസ്തമായി നിശ്ചയിച്ചിരിക്കുന്നതാണ്.
              ഒരേസമയം നിരവധി ചോദ്യങ്ങൾക്ക് പ്രവചനങ്ങൾ നൽകാൻ ഉപയോക്താക്കൾക്ക്
              കഴിയും. ഓരോ മത്സരവും കഴിഞ്ഞ ശേഷം ലീഡർബോർഡ് അപ്‌ഡേറ്റ്
              ചെയ്യപ്പെടും.മുൻനിര പ്രവചകന്റെ ഫോട്ടോ വെബ്സൈറ്റ്/ആപ്പിൽ
              പ്രദർശിപ്പിക്കും. പ്രവചനങ്ങൾ മത്സരം ആരംഭിക്കുന്നതിന് മുൻപുവരെ
              മാറ്റിക്കൊടുക്കാനും കഴിയും. പ്രദർശിപ്പിക്കുന്ന എല്ലാ സമയങ്ങളും
              IST (ഇന്ത്യൻ സ്റ്റാൻഡേർഡ് സമയം) അനുസരിച്ചാണ്.
            </p>
          </div>
          <div className="mobileTermsConditions-content-wrapper">
            <h3>വിജയികളും സമ്മാനങ്ങളും</h3>
          </div>
          <div className="mobileTermsConditions-content-wrapper">
            <h3>Daily Winner</h3>
            <p>
              ഓരോ ദിവസവും ഏറ്റവും കൂടുതൽ പോയിന്റ് നേടിയ daily winner
              പ്രഖ്യാപിക്കും. ഒരേപോലെ points നേടിയവർ ഉണ്ടെങ്കിൽ, വിജയിയെ random
              തിരഞ്ഞെടുക്കും. വിജയിയുമായി ബന്ധപ്പെടാൻ കഴിയാത്ത പക്ഷം മറ്റൊരാളെ
              random തെരഞ്ഞെടുക്കും.
            </p>
          </div>
          <div className="mobileTermsConditions-content-wrapper">
            <h3>Weekly Winner</h3>
            <p>
              ഓരോ ആഴ്ചയും ഏറ്റവും കൂടുതൽ points നേടിയ weekly winner
              പ്രഖ്യാപിക്കും. ഒരേപോലെ points ഉള്ളവർ ഉണ്ടെങ്കിൽ, വിജയിയെ random
              തിരഞ്ഞെടുക്കും. വിജയിയുമായി ബന്ധപ്പെടാൻ കഴിയാത്ത പക്ഷം മറ്റൊരാളെ
              random തെരഞ്ഞെടുക്കും.
            </p>
          </div>
          <div className="mobileTermsConditions-content-wrapper">
            <h3>Mega Winners</h3>
            <p>
              സീസണിന്റെ അവസാനം, ഏറ്റവും ഉയർന്ന points അടിസ്ഥാനമാക്കി multiple
              mega winners തിരഞ്ഞെടുക്കപ്പെടും. 1st, 2nd, 3rd സ്ഥാനങ്ങൾ
              ലഭിക്കുന്നവരും ഉൾപ്പെടും. രണ്ട് അല്ലെങ്കിൽ അതിലധികം പങ്കെടുത്തവർക്ക് ഒരേ സ്കോറും ഒരേ എണ്ണം ചോദ്യങ്ങളിൽ പങ്കെടുത്തതുമാണെങ്കിൽ, അന്തിമ വിജയിയെ തിരഞ്ഞെടുക്കുമ്പോൾ, മൊത്തം സ്കോറിലും പങ്കെടുക്കലിലും സമനില ഉണ്ടെങ്കിൽ, കളിയുടെ നീതി ഉറപ്പാക്കുന്നതിനായി കൂടുതൽ ശരിയായ ഉത്തരങ്ങൾ നൽകിയ പങ്കെടുത്തവനെ വിജയിയായി തീരുമാനിക്കും.
            </p>
          </div>

          <div className="mobileTermsConditions-content-wrapper">
            <h3>Disclaimer</h3>
            <p>
              ഈ മത്സരം സംഘടിപ്പിക്കുന്നത് <strong>Media One</strong>
              -യും ആപ്പിന്റെ സാങ്കേതിക പങ്കാളി <strong>PlaySpots</strong> -ഉം
              ആണ് .<strong>Apple Inc.</strong> ഈ മത്സരത്തിന്റെ സ്പോൺസറോ ,
              അല്ലെങ്കിൽ ഇതുമായി ബന്ധപ്പെട്ടു പ്രവർത്തിക്കുന്നതോ അല്ല .
              മത്സരവുമായി ബന്ധപ്പെട്ടോ സാങ്കേതിക പ്രശ്നങ്ങളോ സംശയങ്ങളോ
              അറിയിക്കാൻ ദയവായി Media One- യോ അല്ലെങ്കിൽ PlaySpotsനെയോ മാത്രം ബന്ധപ്പെടുക. മത്സരവുമായി ബന്ധപ്പെട്ട എല്ലാ കാര്യങ്ങളിലെയും അന്തിമ തീരുമാനം Media One ടീമിനായിരിക്കും.
            </p>
          </div>

          {/*<div className="mobileTermsConditions-content-wrapper">*/}
          {/*  /!*<button>*!/*/}
          {/*  /!*  <a*!/*/}
          {/*  /!*    href="https://www.mediaoneonline.com/preview/story-66571"*!/*/}
          {/*  /!*    target="_blank"*!/*/}
          {/*  /!*  >*!/*/}
          {/*  /!*    മലയാളത്തിൽ വായിക്കുക*!/*/}
          {/*  /!*  </a>*!/*/}
          {/*  /!*</button>*!/*/}
          {/*</div>*/}
          {/* <div className="mobileTermsConditions-content-wrapper">
            <h3>Conditons</h3>
            <p>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry’s standard dummy text
              ever since the 1500s, when an unknown printer took a galley of
              type and scrambled it to make a type specimen book. It has
              survived not only five centuries, but also the leap into
              electronic typesetting, remaining essentially unchanged. It was
              popularised in the 1960s with the release of Letraset sheets
              containing Lorem Ipsum passages, and more recently with desktop
              publishing software like Aldus PageMaker including versions of
              Lorem Ipsum.
            </p>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default MobileTermsConditions;
